import { Component, Container, LocalCache, PuzzleButton } from "puzzle";
import React from "react";
import { DATA } from "../AnnouncementDialog";

type STATE = {
  firstName: string,
  isHidden: boolean
}

type PROPS = {
  announcementData: DATA[],
  firstName: string,
  isImpersonatedUser: boolean // Shows if user is being impersonated or not
}

class AnnouncementRibbon extends Component<PROPS, STATE> {

  state: STATE = {
    firstName: '',
    isHidden: false
  }

  /**
   * Opens Announcement dialog
   */
  openAnnouncementDialog = () => {
    const { firstName, announcementData } = this.props
    this.dispatch('announcementDialog', '', { announcementData, firstName })
  }

  /**
   * Removes Announcement ribbon for the duration of session
   */
  removeAnnouncementRibbon = () => {
    const { isHidden } = this.state
    LocalCache.setItem('hideAnnouncement', 'true');
    this.setState({ isHidden: !isHidden })
  }


  renderBody() {
    const { isHidden } = this.state
    const { announcementData, isImpersonatedUser } = this.props
    return (
      isHidden ? null
        :
        <Container
          alignItemsCenter
          displayFlex
          justifyContentCenter
          className={"pd-header-ribbon pd-announcement-ribbon tp-text-semibold tp-font-size-sm"}>
          <Container
            alignItemsCenter
            displayFlex
            justifyContentCenter
          >
            <i className={'tp-icon tp-volume-up tp-font-size-xl tp-space-right-half-1'} role={'presentation'} />
            <span className={'tp-text-ellipsis pd-announcement-ribbon-text tp-text-medium'}>
            {announcementData?.length ? announcementData[0].subject : null}
          </span>
            <span
              className={'pd-ribbon-btn-link tp-text-underline tp-pointable'}
              role={'button'}
              tabIndex={0}
              onClick={this.openAnnouncementDialog}
            >
          {announcementData?.length > 1 ?
            this.translate('showDetails', { announcements: announcementData?.length }) : this.translate('showDetail')
          }
        </span>
          </Container>

          <Container
            alignItemsCenter
            displayFlex
            justifyContentEnd
            className={'k-pr-3'}
          >
            {isImpersonatedUser ? null :
              <PuzzleButton
                className={'k-justify-content-end'}
                fillMode="flat"
                size={'small'}
                onClick={() => this.dispatch('removeAnnouncementRibbon')}
                iconClass="tp-icon tp-x" />
            }
          </Container>
        </Container>
    );
  }
}

export default AnnouncementRibbon;
